export const environment = {
  production: false,
  apiUrl: 'https://sportiq-backoffice-api.digi4dev.ma',
  baseDomain: 'sportiq-backoffice.digi4dev.ma',
  federationSlug: 'frmtt',
  version: '1.0.0'
};
